export const arrowIcon = `Table of contents <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 2.41421L10.2929 6.70711C10.6834 7.09763 11.3166 7.09763 11.7071 6.70711C12.0976 6.31658 12.0976 5.68342 11.7071 5.29289L6.70711 0.292893C6.31658 -0.0976311 5.68342 -0.0976311 5.29289 0.292893L0.292893 5.29289C-0.0976311 5.68342 -0.0976311 6.31658 0.292893 6.70711C0.683418 7.09763 1.31658 7.09763 1.70711 6.70711L6 2.41421Z"
      fill="#2D2926"
    />
  </svg>`;
